import styled from 'styled-components';
import { Title } from '../title';
import { Button } from '../button';
export const ModalBackdrop = styled.div `
  opacity:.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100%;
  height: 100vh;
  background-color: #000;
`;
export const ModalComponent = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow: auto;
  pointer-events: auto;
`;
export const ModalDialog = styled.div `
  max-width: ${({ width }) => width || 360}px;
  width: 100%;
  max-height: 100%;
`;
export const ModalContent = styled.div `
  margin: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  outline: 0;
  background-color: #fff;
  width: 100%;
  min-height: 100vh;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  
  @media (min-width: ${({ theme }) => theme.screen.smMin}){
    margin: 40px auto;
    border-radius: 8px;
    width: auto;
    min-height: 0;
    overflow: visible;
  }
`;
export const ModalHeader = styled.div `
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.mobile.padding};
  
  @media (min-width: ${({ theme }) => theme.screen.smMin}){
    padding: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.desktop.padding};
    padding: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.desktop.padding};
  }
`;
export const Heading = styled(Title) `
  font-weight: 600;
  font-size: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.mobile.title.fontSize};
  line-height: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.mobile.title.lineHeight};
  text-align: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.mobile.textAlign};
  color: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.mobile.color};
  ${({ skin }) => !skin || skin === 'with-form' ? 'width: 90vw;' : ``}

  @media (min-width: ${({ theme }) => theme.screen.smMin}){
    font-size: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.desktop.title.fontSize};
    line-height: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.desktop.title.lineHeight};
    text-align: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.desktop.textAlign};
    color: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.desktop.color};
    ${({ skin }) => !skin || skin === 'with-form' ? 'width: auto;' : ``}
  }
`;
export const SubTitle = styled.p `
  font-weight: 600;
  margin: 16px 0 0 0;
  font-size: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.mobile.subtitle.fontSize};
  line-height: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.mobile.subtitle.lineHeight};
  text-align: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.mobile.textAlign};
  color: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.mobile.color};

  @media (min-width: ${({ theme }) => theme.screen.smMin}){
    font-size: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.desktop.subtitle.fontSize};
    line-height: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.desktop.subtitle.lineHeight};
    text-align: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.desktop.textAlign};
    color: ${({ skin, theme }) => theme.modal[skin || 'with-form'].header.desktop.color};
  }
`;
export const CustomButton = styled(Button) `
  background: transparent;
  position: absolute;
  top: 4px;
  right: 0;
  padding: 0;
  margin: 0;
  border: 0;
  line-height: 1;

  &:focus{
    outline: transparent;
  }
  
  @media (min-width: ${({ theme }) => theme.screen.smMin}){
    top: 12px;
    right: 12px;
  }
`;
export const ModalBody = styled.div `
  position: relative;
  padding: 0px 4px;
  line-height:1.75rem;
  
  @media (min-width: ${({ theme }) => theme.screen.smMin}){
    padding: 0px 36px;
    flex: 1 1 auto;
  }
`;
export const ModalFooter = styled.div `
  padding: 0 0 48px;
`;
